import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncMarkerMap = asyncComponent({
    resolve: () => import(
        /* webpackChunkName: "map" */
        './MarkerMap'
    ),
    LoadingComponent: () => <span />,
    serverMode: 'defer'
});
